// import $ from '../lib/jquery';
import { toggleInert, toggleScrollAccessibility } from '../lib/helpers';

export function initHeader() {
	/* Scroll header */
	$(window).on('scroll', function () {
		if ($(document).scrollTop() > 130) {
			$('.site-header').addClass('scrolled');
		} else {
			$('.site-header').removeClass('scrolled');
		}
	});

	/* Detect scroll direction */
	let lastScrollTop = 0;
	$(window).on('scroll', function () {
		const st = $(this).scrollTop();
		if (st > lastScrollTop && st !== 0) {
			$('.site-header').addClass('down');
		} else {
			$('.site-header').removeClass('down');
		}
		lastScrollTop = st;
	});

	/* Language Switcher */
	$('.language.is-active').on('click', function () {
		return false;
	});

	/* Open/Close Menu */
	// $('.menu_button').on('click', function () {
	// 	const isActive = $(this).hasClass('is-active');

	// 	if (isActive) {
	// 		// Close menu
	// 		$('body').css('overflow-y', 'scroll');
	// 		$(this).removeClass('is-active');
	// 		$('.header_menu_controls .menu_button').removeClass('is-active');
	// 		$('.header_menu_controls .menu_button').addClass('is-active');
	// 		$('.site-header').removeClass('openmenu');
	// 	} else {
	// 		// Open menu
	// 		$(this).addClass('is-active');
	// 		$('.header_menu_controls .menu_button').addClass('is-active');
	// 		$('body').css('overflow-y', 'hidden');
	// 		$('.headermenu').addClass('is-active');
	// 		$('.site-header').addClass('openmenu');
	// 	}
	// });

	$(function ($) {
		const $menuItems = $('.menu-item-has-children');

		function closeAll() {
			$menuItems.attr('aria-expanded', 'false');
		}

		$menuItems.on('click', function (e) {
			e.stopPropagation();
			// if ($('.site-header').hasClass('scrolled') || $('.site-header').hasClass('down')) {
			// 	$('.site-header').removeClass('scrolled');
			// 	$('.site-header').removeClass('down');
			// }
			const $this = $(this);
			const isExpanded = $this.attr('aria-expanded') === 'true';

			closeAll();

			if (!isExpanded) {
				$this.attr('aria-expanded', 'true');
			}
		});
		$(document).on('click', function () {
			closeAll();
		});
	});

	$(function ($) {
		const $btnOpen = $('#openToggle');
		const $btnClose = $('#closeToggle');
		const $topNavMenu = $('.mobile-menu-offcanvas');
		const $main = $('main');
		const $body = $('body');

		const media = window.matchMedia('(width < 1300px)');

		function openMobileMenu() {
			$btnOpen.attr('aria-expanded', 'true');
			$topNavMenu.addClass('active-canvas');
			$topNavMenu.removeAttr('inert').removeAttr('style');
			$main.attr('inert', '');
			toggleScrollAccessibility($body, true);
			$btnClose.trigger('focus');
		}

		function closeMobileMenu() {
			$btnOpen.attr('aria-expanded', 'false');
			$topNavMenu.removeClass('active-canvas');
			$topNavMenu.attr('inert', '');
			$main.removeAttr('inert');
			toggleScrollAccessibility($body, false);
			$btnOpen.trigger('focus');

			setTimeout(function () {
				$topNavMenu.css('transition', 'none');
			}, 500);
		}

		function setupTopNav(e) {
			if (e.matches) {
				// mobile
				$topNavMenu.attr('inert', '');
				$topNavMenu.css('transition', 'none');
			} else {
				// tablet/desktop
				closeMobileMenu();
				$topNavMenu.removeAttr('inert');
			}
		}

		// Initial check
		setupTopNav(media);
		// Click events
		$btnOpen.on('click', openMobileMenu);
		$btnClose.on('click', closeMobileMenu);
		// Media query change listener
		media.addEventListener('change', function (e) {
			setupTopNav(e);
		});
	});
}
